// extracted by mini-css-extract-plugin
module.exports = {"ClientsDrawerItems":"ClientsDrawerItems_ClientsDrawerItems__2TfA_","innerListItemText":"ClientsDrawerItems_innerListItemText__2ydko"};